import { makeStyles } from "@material-ui/core/styles";

export const projectTypes = [
  { value: "all", label: "All Projects" },
  { value: "important", label: "Important" },
  { value: "regular", label: "Regular" },
  { value: "archived", label: "Archived" },
  { value: "draft", label: "Draft" },
  { value: "completed", label: "Completed" }
];

export const useProjectTypeStyles = makeStyles((theme) => ({
  projectType: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  projectTypeImportant: {
    backgroundColor: '#ffebee',
    color: '#c62828',
  },
  projectTypeRegular: {
    backgroundColor: '#e3f2fd',
    color: '#1565c0',
  },
  projectTypeArchived: {
    backgroundColor: '#f5f5f5',
    color: '#616161',
  },
  projectTypeDraft: {
    backgroundColor: '#fff3e0',
    color: '#ef6c00',
  },
  projectTypeCompleted: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
  },
  menuItem: {
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
  },
  menuItemDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    marginRight: '8px',
  },
  menuItemImportant: {
    backgroundColor: '#ffebee',
    '&:hover': {
      backgroundColor: '#ffcdd2',
    },
  },
  menuItemRegular: {
    backgroundColor: '#e3f2fd',
    '&:hover': {
      backgroundColor: '#bbdefb',
    },
  },
  menuItemArchived: {
    backgroundColor: '#f5f5f5',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
  },
  menuItemDraft: {
    backgroundColor: '#fff3e0',
    '&:hover': {
      backgroundColor: '#ffe0b2',
    },
  },
  menuItemCompleted: {
    backgroundColor: '#e8f5e9',
    '&:hover': {
      backgroundColor: '#c8e6c9',
    },
  },
  dotImportant: {
    backgroundColor: '#c62828',
  },
  dotRegular: {
    backgroundColor: '#1565c0',
  },
  dotArchived: {
    backgroundColor: '#616161',
  },
  dotDraft: {
    backgroundColor: '#ef6c00',
  },
  dotCompleted: {
    backgroundColor: '#2e7d32',
  },
}));

export const getProjectTypeLabel = (type) => {
  const typeObj = projectTypes.find(t => t.value === type);
  return typeObj ? typeObj.label : type;
};

export const getProjectTypeStyle = (classes, type) => {
  const baseClass = classes.projectType;
  const typeClass = classes[`projectType${type.charAt(0).toUpperCase() + type.slice(1)}`] || '';
  return `${baseClass} ${typeClass}`;
};

export const getMenuItemStyle = (classes, type) => {
  if (type === 'all') return {};
  return classes[`menuItem${type.charAt(0).toUpperCase() + type.slice(1)}`];
};

export const getDotStyle = (classes, type) => {
  if (type === 'all') return {};
  return classes[`dot${type.charAt(0).toUpperCase() + type.slice(1)}`];
}; 